/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useEffect, useState, useCallback } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import api from '../../services/api';

import { ModalStyle } from './styles';

import Bitcoin from '../../assets/coins/Bitcoin.svg';
import BitcoinCash from '../../assets/coins/BitcoinCash.svg';
import BitcoinGold from '../../assets/coins/BitcoinGold.svg';
import BitcoinSV from '../../assets/coins/BitcoinSV.svg';
import Dash from '../../assets/coins/Dash.svg';
import Digibyte from '../../assets/coins/Digibyte.svg';
import Dogecoin from '../../assets/coins/Dogecoin.svg';
import Eos from '../../assets/coins/Eos.svg';
import Ethereum from '../../assets/coins/Ethereum.svg';
import EthereumClassic from '../../assets/coins/EthereumClassic.svg';
import Komodo from '../../assets/coins/Komodo.svg';
import Lisk from '../../assets/coins/Lisk.svg';
import Litecoin from '../../assets/coins/Litecoin.svg';
import Neo from '../../assets/coins/Neo.svg';
import Qtum from '../../assets/coins/Qtum.svg';
import Ripple from '../../assets/coins/Ripple.svg';
import Stellar from '../../assets/coins/Stellar.svg';
import Stratis from '../../assets/coins/Stratis.svg';
import Tether from '../../assets/coins/Tether.svg';
import Tron from '../../assets/coins/Tron.svg';
import Waves from '../../assets/coins/Waves.svg';
import Zcash from '../../assets/coins/Zcash.svg';

interface arrayValue {
  id: string;
  basebet: number;
  current_price: number;
  price: number;
  image: string;
  name: string;
  symbol: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const ModalBounty = (props: any) => {
  const { buttonLabel, className, modalTitle, bountyId, round } = props;

  const [dataOfCurrency, setDataOfCurrency] = useState([]);

  const updateNumberOfRoll = useCallback(async () => {
    const response = await api.get(`/bountyRoll/${round}/${bountyId.bountyId}`);
    if (response.data[0]) {
      setDataOfCurrency(JSON.parse(response.data[0].currencies));
    }
  }, [bountyId.bountyId, round]);

  useEffect(() => {
    updateNumberOfRoll();
  }, [updateNumberOfRoll]);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const changedImagesOfCurrencies = dataOfCurrency.map(
    (currency: arrayValue) => {
      if (currency.id === 'tether') {
        currency.image = Tether;
      } else if (currency.id === 'bitcoin') {
        currency.image = Bitcoin;
      } else if (currency.id === 'ethereum') {
        currency.image = Ethereum;
      } else if (currency.id === 'ripple') {
        currency.image = Ripple;
      } else if (currency.id === 'litecoin') {
        currency.image = Litecoin;
      } else if (currency.id === 'dogecoin') {
        currency.image = Dogecoin;
      } else if (currency.id === 'ethereum-classic') {
        currency.image = EthereumClassic;
      } else if (currency.id === 'bitcoin-cash') {
        currency.image = BitcoinCash;
      } else if (currency.id === 'zcash') {
        currency.image = Zcash;
      } else if (currency.id === 'digibyte') {
        currency.image = Digibyte;
      } else if (currency.id === 'eos') {
        currency.image = Eos;
      } else if (currency.id === 'stellar') {
        currency.image = Stellar;
      } else if (currency.id === 'tron') {
        currency.image = Tron;
      } else if (currency.id === 'dash') {
        currency.image = Dash;
      } else if (currency.id === 'bitcoin-cash-sv') {
        currency.image = BitcoinSV;
      } else if (currency.id === 'bitcoin-gold') {
        currency.image = BitcoinGold;
      } else if (currency.id === 'neo') {
        currency.image = Neo;
      } else if (currency.id === 'stratis') {
        currency.image = Stratis;
      } else if (currency.id === 'komodo') {
        currency.image = Komodo;
      } else if (currency.id === 'lisk') {
        currency.image = Lisk;
      } else if (currency.id === 'qtum') {
        currency.image = Qtum;
      } else if (currency.id === 'waves') {
        currency.image = Waves;
      }
      return currency;
    },
  );

  const filterOfDataFirst = changedImagesOfCurrencies.filter(
    (currency: arrayValue, index) => {
      return index < 11;
    },
  );

  const filterOfDataSecond = changedImagesOfCurrencies.filter(
    (currency, index) => {
      return index >= 11;
    },
  );

  return (
    <>
      <Button onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalStyle>
          <ModalHeader toggle={toggle}> {modalTitle}</ModalHeader>
          <ModalBody>
            <div className="firstColumn">
              {filterOfDataFirst.map((currency: arrayValue) => {
                return (
                  <div className="mainDiv" key={currency.symbol}>
                    <div className="childrenDiv">
                      <img src={currency.image} alt={currency.symbol} />
                      <p>{currency.name}</p>
                    </div>
                    <p>
                      {Number(currency.basebet).toFixed(8)}{' '}
                      {currency.symbol.toUpperCase()}
                    </p>
                  </div>
                );
              })}
            </div>
            <div className="secondColumn">
              {filterOfDataSecond.map((currency: arrayValue) => {
                return (
                  <div className="mainDiv" key={currency.symbol}>
                    <div className="childrenDiv">
                      <img src={currency.image} alt={currency.symbol} />
                      <p>{currency.name}</p>
                    </div>
                    <p>
                      {Number(currency.basebet).toFixed(8)}{' '}
                      {currency.symbol.toUpperCase()}
                    </p>
                  </div>
                );
              })}
            </div>
          </ModalBody>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default ModalBounty;
